import { render, staticRenderFns } from "./Chunk.vue?vue&type=template&id=031b4f09"
import script from "./Chunk.vue?vue&type=script&lang=js"
export * from "./Chunk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports